export default {
  PRE_TRADING_AGREEMENT: 'PRE_TRADING_AGREEMENT',
  AUCTION: 'AUCTION',
};
